import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = {
    createFetchParams: (search, pagination) => ({...pagination, search}),
    ...storeModuleFactory({
        name:               'impersonateCustomers',
        endpoint:           endpoints.impersonateUser.customerEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: item => item.results.map(customer => ({
            id:   customer.id,
            name: customer.company_name
        }))
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/impersonateCustomers.js